<section class="shivsewa-hero-section">
  <!-- Desktop Carousel -->
  <p-carousel
    *ngIf="!isMobileView"
    [value]="bannerImages"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="true"
    [autoplayInterval]="6000"
    [showIndicators]="false"
    [showNavigators]="false"
    styleClass="shivsewa-hero-bg hero-carousel"
  >
    <ng-template pTemplate="item" let-img>
      <div class="hero-slide">
        <img [src]="img" alt="Shiv Sewa cab service banner" class="shivsewa-hero-image" />
      </div>
    </ng-template>
  </p-carousel>

  <!-- Mobile Slider -->
  <div *ngIf="isMobileView" class="mobile-hero-slider" #mobileSlider>
    <div
      class="mobile-slide"
      *ngFor="let img of bannerImages"
      [style.backgroundImage]="'url(' + img + ')'"
      role="img"
      aria-label="Shiv Sewa cab service banner"
    ></div>
  </div>

  <div class="shivsewa-hero-container">
    <h1 class="shivsewa-hero-heading">
      The City Never Stops,<br />
      The Service Never Fails.
    </h1>

    <form id="shivsewa-booking-form" class="shivsewa-booking-panel" (submit)="bookNow($event)">
      <!-- 1. SELECT TRIP TYPE -->
      <div class="section-header">1. SELECT TRIP TYPE</div>
      <div class="trip-type-selector">
        <button
          type="button"
          class="trip-type-btn"
          [class.active]="selectedTripType === 'pickup-drop'"
          (click)="selectTripType('pickup-drop')"
        >
          <i class="fa-solid fa-location-dot"></i>
          <span>Pickup & Drop</span>
        </button>

        <button
          type="button"
          class="trip-type-btn"
          [class.active]="selectedTripType === 'outstation'"
          (click)="selectTripType('outstation')"
        >
          <i class="fa-solid fa-car"></i>
          <span>Outstation</span>
        </button>

        <button
          type="button"
          class="trip-type-btn"
          [class.active]="selectedTripType === 'rental'"
          (click)="selectTripType('rental')"
        >
          <i class="fa-regular fa-clock"></i>
          <span>Rental</span>
        </button>
      </div>

      <!-- 2. SELECT VEHICLE CATEGORY -->
      <div class="section-header">2. SELECT VEHICLE CATEGORY</div>
      <div class="vehicle-category-grid">
        <ng-container *ngFor="let category of vehicleCategories">
    <div
      *ngIf="!(selectedTripType === 'pickup-drop' && category === 'suvPlus')"
      class="vehicle-category-card"
      [class.active]="selectedVehicleCategory === category"
      (click)="selectVehicleCategory(category)"
    >
      <img
        [src]="carData[category][0].image"
        [alt]="getVehicleCategoryName(category)"
        class="vehicle-category-image"
      />
      <div class="vehicle-name">
        {{ getVehicleCategoryName(category) }}
      </div>
    </div>
  </ng-container>
      </div>

      <!-- 3. ENTER LOCATIONS -->
      <div class="section-header">3. ENTER LOCATIONS</div>
      <div class="trip-form">
        <div class="ride-inputs-wrapper">
          <!-- Pickup -->
          <div class="error-text" *ngIf="pickupError">
            {{ pickupError }}
          </div>
          <div class="ride-input-group pickup-group" #pickupGroup>
            <div class="location-indicator location-indicator-empty"></div>
            <input
              type="text"
              placeholder="Enter Pickup Point"
              [(ngModel)]="pickupLocation"
              (input)="filterPickup(pickupLocation)"
              name="pickup"
              class="ride-input"
              required
            />
            <div class="location-button location-button-gps" (click)="useCurrentLocation()">
              <i class="fa-solid fa-location-crosshairs icon-specific"></i>
            </div>
            <ul class="autocomplete-box" *ngIf="pickupSuggestions.length > 0">
              <li *ngFor="let s of pickupSuggestions" (click)="selectPickupLocation(s)">
                <i class="bi bi-geo-alt-fill icon-specific"></i> &nbsp; {{ s.name }}
              </li>
            </ul>
          </div>

          <div class="connector-line-wrapper">
            <div class="connector-line"></div>
          </div>

          <!-- Drop -->
          <div class="error-text" *ngIf="dropError">
            {{ dropError }}
          </div>
          <div class="ride-input-group drop-group" #dropGroup>
            <div class="location-indicator location-indicator-filled"></div>
            <input
              type="text"
              placeholder="Enter Destination"
              [(ngModel)]="dropLocation"
              (input)="filterDrop(dropLocation)"
              [disabled]="!pickupLocation"
              name="drop"
              class="ride-input"
              required
            />
            <div class="location-icon">
              <i class="fa-solid fa-map-pin icon-specific"></i>
            </div>
            <ul class="autocomplete-box" *ngIf="dropSuggestions.length > 0">
              <li *ngFor="let s of dropSuggestions" (click)="selectDropLocation(s)">
                <i class="bi bi-geo-alt-fill icon-specific"></i> &nbsp; {{ s.name }}
              </li>
            </ul>
          </div>
        </div>

        <div class="quick-ride-button-wrapper">
          <button type="submit" [disabled]="!isFormValid()" class="request-ride-button">
            Request Ride
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
